import { useIsMobile } from "../volleyball/context/mobileContext";
import NBADesktopDashboard from "./screens/nbaDesktopDashboard";
import NBAMobileDashboard from "./screens/nbaMobileDashboard";

const NBADashboard = () => {
  const isMobile = useIsMobile();
  return isMobile ? <NBAMobileDashboard /> : <NBADesktopDashboard />;
};

export default NBADashboard;
